export const getProfilePeopleShortCutOuterContainerStyle = (theme) => ({
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    maxWidth: theme.isDesktop() ? '52.5rem' : '36.5rem',
    marginBottom: '2rem',
    textAlign: 'center',
    display: 'flex',
    flexWrap: 'wrap'
});